module.exports = __webpack_public_path__ + "img/topo_cadastro_.ca8601c5.jpg";